import { useState } from 'react';
import { Box, Button, Center, Image, Stack, Text, Title } from '@mantine/core';

import imgError from '@shared/img/error/error.svg';

export const SomethingWentWrong = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = () => {
    setIsRefreshing(true);
    window.location.reload();
  };

  if (import.meta.env.MODE_FEATURE_FLAG_REDESIGN_MANTINE !== 'on') {
    return (
      <div className='account'>
        <div className='account__wrapper'>Something went wrong</div>
      </div>
    );
  }

  return (
    <Center mih='100vh' p='xl'>
      <Box pos='relative' w='100%' maw={632}>
        <Stack gap='lg' align='center'>
          <Image src={imgError} alt='' w={332} h={160} fit='contain' />
          <Stack gap='sm' align='center'>
            <Title order={3} ta='center'>
              Something went wrong
            </Title>
            <Text size='xl' ta='center'>
              We couldn't complete your request due to an unexpected error.
              <br />
              If the problem persists, please contact your manager or try again
              later.
            </Text>
          </Stack>
          <Stack gap='sm' align='center'>
            <Button w={332} loading={isRefreshing} onClick={handleRefresh}>
              Refresh page
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Center>
  );
};
